import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip,
    Chip
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import "../../../styles/Auth/store.css";
import EmployeeMultiSelectAsync from "../../Challange/userMultiSelect.jsx";
import ClusterManagerSelectAsync from "../../Challange/ClusterSelect.jsx";
import StoreAdminSelectAsync from "../../Challange/storeAdminSelect.jsx";
import { AsyncPaginate } from "react-select-async-paginate";
import TVFMLoader from "../Loader/loader.jsx";
import AddStoreForm from "./AddStoreForm.jsx";
import Footer from "../Footer/Footer-page.jsx";
import { useSubscriptionRenewal } from '../../../context/SubscriptionRenewalContext.jsx';
import PackageInvoiceModal from '../../../components/Subscription/PackageInvoiceModal.jsx';

const StorePage = () => {
    const { openRenewPackageModal } = useSubscriptionRenewal();
    const role = localStorage.getItem("role");
    const isFranchiseAdmin = role === "FranchiseAdmin";

    const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
    const [invoiceSubId, setInvoiceSubId] = useState(null);

    const navigate = useNavigate();
    const location = useLocation();
    const isAddStore = location.pathname === '/stores/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.NO',
        'Store Name',
        'Email',
        'Phone Number',
        'Action',
    ];

    const getStoreDisplayName = (store) => {
        let name = store?.branchName || store?.storeName || store?.name || store?.storeId || "";
        if (name === "undefined" || name === "null") name = "";
        name = String(name).trim();

        let location = store?.location || "";
        if (location === "undefined" || location === "null") location = "";
        location = String(location).trim();

        if (name && location) {
            return `${name} - ${location}`;
        }
        if (name) {
            return name;
        }
        if (location) {
            return location;
        }
        return "-";
    };
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [stateError, setStateError] = useState("");
    const sessionToken = localStorage.getItem("Token");
    const [searchQuery, setSearchQuery] = useState('');
    const [storesToDelete, setStoresToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editStoreId, setEditStoreId] = useState(null);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [assignPopup, setAssignPopup] = useState(false);
    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [assignLoading, setAssignLoading] = useState(false);
    const [showAddStorePopup, setShowAddStorePopup] = useState(false);
    const [storeImage, setStoreImage] = useState(null);
    const [storeLogo, setStoreLogo] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    const [isViewStore, setIsViewStore] = useState(false);
    const [viewStoreData, setViewStoreData] = useState(null);
    const sort = [[sortField, sortOrder]];


    const decryptData = (encryptedData) => {
        try {
            if (!encryptedData || typeof encryptedData !== 'string') return encryptedData;

            // Format check: iv:ciphertext
            if (encryptedData.includes(':')) {
                const parts = encryptedData.split(':');
                if (parts.length !== 2) return encryptedData;

                const iv = CryptoJS.enc.Hex.parse(parts[0]);
                const encrypted = CryptoJS.enc.Hex.parse(parts[1]);

                // standard key for this project family
                const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");

                const decrypted = CryptoJS.AES.decrypt(
                    { ciphertext: encrypted },
                    key,
                    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
                );

                const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
                return decryptedText || encryptedData;
            }

            // Fallback for simple encryption if ever used
            const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012");
            const bytes = CryptoJS.AES.decrypt(encryptedData, key);
            const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
            return decryptedText || encryptedData;
        } catch (error) {
            console.error("Decryption failed:", error);
            return encryptedData;
        }
    };

    const handleSort = (field) => {
        if (!field || typeof field !== "string") return;

        setCurrentPage(1); // ✅ Reset page on sort

        setSortField(prevField => {
            if (prevField === field) {
                setSortOrder(prev => (prev === 1 ? -1 : 1));
                return prevField;
            } else {
                setSortOrder(1); // default ASC for new field
                return field;
            }
        });
    };
    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');
    const [formData, setFormData] = useState({
        // franchisorId: '',
        storeName: '',
        branchName: '',
        phoneNumber: '',
        emailAddress: '',
        address: '',
        postalCode: '',
        state: '',
        country: '',
        description: '',
        location: '',
        storeImageObject: "",
        storeLogoImageObject: "",
        documents: [],
        employees: [],
        brandName: "",
        employeeNames: {},
        clusterManager: "",
        clusterManagerName: "",
        gstData: {
            gstNumber: '',
            valid: false,
            status: 'PENDING'
        },
        storeAdmin: "",
        isFranchiseAvailable: false,


    });

    const [documents, setDocuments] = useState([
        { documentType: "", documentName: "", files: [] }
    ]);

    const [errors, setErrors] = useState({});

    const validateStoreForm = () => {
        let newErrors = {};
        let valid = true;

        // Basic fields
        if (!formData.branchName?.trim()) {
            newErrors.branchName = "Branch Name is required";
            valid = false;
        }
        if (!formData.emailAddress?.trim()) {
            newErrors.emailAddress = "Store Email Address is required";
            valid = false;
        }
        if (!formData.phoneNumber || formData.phoneNumber.length !== 10) {
            newErrors.phoneNumber = "Phone Number must be 10 digits";
            valid = false;
        }
        if (!formData.address?.trim()) {
            newErrors.address = "Address is required";
            valid = false;
        }
        if (!formData.postalCode?.trim()) {
            newErrors.postalCode = "Postal Code is required";
            valid = false;
        }
        if (!formData.state?.trim()) {
            newErrors.state = "State is required";
            valid = false;
        }

        if (!formData.country?.trim()) {
            newErrors.country = "Country is required";
            valid = false;
        }

        // ⭐ DOCUMENT VALIDATION


        setErrors(newErrors);
        return valid;
    };

    const addDocumentRow = () => {
        if (documents.length >= 10) {
            alert("You can upload a maximum of 10 document entries.");
            return;
        }
        setDocuments(prev => [
            ...prev,
            { documentType: "", documentName: "", files: [] }
        ]);
    };

    const removeDocumentRow = (index) => {
        setDocuments(prev => prev.filter((_, i) => i !== index));
    };

    const updateDocumentRow = (index, field, value) => {
        const updated = [...documents];
        updated[index][field] = value;
        setDocuments(updated);
    };

    const handleDocumentFiles = (index, fileList) => {
        const files = Array.from(fileList);
        const validFiles = files.filter(f => f.size <= 5 * 1024 * 1024);
        const invalidFiles = files.filter(f => f.size > 5 * 1024 * 1024);

        if (invalidFiles.length > 0) {
            alert("Some files exceed 5 MB limit. They were ignored.");
        }

        const updated = [...documents];
        updated[index].files = validFiles;
        setDocuments(updated);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;

        if (value === "all") {
            setLimit("all");
        } else {
            setLimit(Number(value));
        }

        setCurrentPage(1);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const handleOpen = (storeId) => {
        setStoresToDelete(storeId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setStoresToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };



    const handleUpdateStore = async (e) => {
        e.preventDefault();

        if (!validateStoreForm()) return;

        const token = localStorage.getItem("Token");
        const userId = localStorage.getItem("userId");

        let updatedImageObject = formData.storeImageObject;
        let updatedLogoImageObject = formData.storeLogoImageObject;

        // ✅ If user selected a new image, upload it
        if (storeImage && userId) {
            const uploadResult = await uploadFile(`files/upload/${userId}`, storeImage);

            if (uploadResult?.status === 200 || uploadResult?.success) {
                updatedImageObject = uploadResult.data;
            } else {
                toast.error(uploadResult?.message || "Image upload failed");
                return;
            }
        }

        // ✅ If user selected a new logo, upload it
        if (storeLogo && userId) {
            const uploadResult = await uploadFile(`files/upload/${userId}`, storeLogo);

            if (uploadResult?.status === 200 || uploadResult?.success) {
                updatedLogoImageObject = uploadResult.data;
            } else {
                toast.error(uploadResult?.message || "Logo upload failed");
                return;
            }
        }
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");

            const storeUpdateData = {
                storeName: formData.branchName || formData.storeName,
                branchName: formData.branchName,
                emailAddress: formData.emailAddress,
                phoneNumber: formData.phoneNumber,
                address: formData.address,
                brandName: formData.brandName,
                postalCode: formData.postalCode,
                state: formData.state,
                country: formData.country,
                location: formData.location,
                description: formData.description,
                storeAdmin: formData.storeAdmin || null,
                clusterManager: formData.clusterManager || null,
                employees: formData.employees || [],
                gstData: {
                    gstNumber: formData.gstData?.gstNumber || "",
                    status: formData.gstData?.status || "PENDING"
                    // ❌ do NOT send valid
                },
                documents: [],
                storeImageObject: updatedImageObject,
                storeLogoImageObject: updatedLogoImageObject,
            };

            // --------------------------
            //  DOCUMENT UPLOAD LOGIC
            // --------------------------
            for (let i = 0; i < documents.length; i++) {
                const doc = documents[i];
                let uploadedFiles = [];

                if (doc.files && doc.files.length > 0) {
                    for (let file of doc.files) {
                        if (file instanceof File) {
                            const uploadRes = await uploadFile(
                                `files/upload/store-docs`,
                                file
                            );

                            if (uploadRes?.status === 200) {
                                uploadedFiles.push(uploadRes.data);
                            }
                        } else {
                            uploadedFiles.push(file);
                        }
                    }
                }

                storeUpdateData.documents.push({
                    documentType: doc.documentType,
                    documentName: doc.documentType === "OTHERS" ? doc.documentName : "",
                    files: uploadedFiles,
                });
            }

            console.log("FINAL UPDATE PAYLOAD →", storeUpdateData);

            const response = await putData(
                `stores/store/${editStoreId}`,
                storeUpdateData,
                token
            );

            toast.success(response.message || "Store updated successfully");

            // ✅ RESET FORM
            setFormData({
                branchName: "",
                emailAddress: "",
                phoneNumber: "",
                address: "",
                postalCode: "",
                state: "",
                country: "",
                location: "",
                description: "",
                clusterManager: "",
                storeAdmin: "",
                employees: [],
                employeeNames: {},
                clusterManagerName: "",
                gstData: {
                    gstNumber: "",
                    status: "PENDING"
                },
                storeImageObject: null,
                storeLogoImageObject: null,
            });

            setStoreLogo(null);
            setLogoPreviewUrl(null);

            setDocuments([{ documentType: "", documentName: "", files: [] }]);

            setIsPopupMode(false);
            triggerRefresh();
            navigate("/stores");

        } catch (error) {
            console.error("Update Store Error:", error);
            toast.error(error.message || "Update Store Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
        }
    };

    const handleViewStore = async (storeId) => {
        try {
            setLoading(true);
            const sessionToken = localStorage.getItem("Token");
            const res = await getData(`stores/store/${storeId}`, {}, sessionToken);
            setViewStoreData(res.data);
            setIsViewStore(true);
        } catch (error) {
            console.error("Failed to fetch store details:", error);
            toast.error("Failed to load store details");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteStore = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("Token");
            const response = await deleteData(`stores/store/${storesToDelete}`, token);
            toast.success(response.message || 'Store deleted successfully');
            setStoresToDelete(null);
            fetchStores(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete Store Error:", error);
            toast.error(error.message || 'Delete Store Failed');
        }
    }

    useEffect(() => {
        const token = localStorage.getItem("Token");
        fetchStores(currentPage, limit, searchQuery, token);
    }, [currentPage, limit, refreshKey, searchQuery, sortField, sortOrder]);

    const fetchStores = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === "all" ? totalCount || 999999 : limit,
            storeName: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        };
        console.log("✅ FINAL STORE SORT PAYLOAD:", params.sort);
        try {
            setLoading(true);
            const response = await getData('stores/stores', params, sessionToken);
            const resultsWrapper = response?.data;
            const customersList = resultsWrapper?.results || [];
            const totalCount = resultsWrapper?.totalItems || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setStores(customersList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            console.error("Failed to load stores", error);
        } finally {
            setLoading(false);
        }
    }
    const loadFranchises = async (search, loadedOptions, { page }) => {
        try {
            const sessionToken = localStorage.getItem("Token");

            const res = await getData(
                "franchise/franchises",
                {
                    page,
                    limit: 10,
                    search: search || "",
                },
                sessionToken
            );

            const results = res?.data?.results || [];
            const hasMore = results.length === 10;

            const options = results.map((f) => ({
                value: f._id,
                label: f.franchiseName,
            }));

            return {
                options,
                hasMore,
                additional: { page: page + 1 },
            };
        } catch (error) {
            console.error("Failed to load franchises", error);
            return {
                options: [],
                hasMore: false,
                additional: { page },
            };
        }
    };

    const handleAssignFranchise = async () => {
        if (!selectedFranchise?.value) {
            alert("Please select a franchise");
            return;
        }
        debugger;
        try {
            setAssignLoading(true);

            const sessionToken = localStorage.getItem("Token");

            await postData(
                `stores/store/${formData._id}/franchise/${selectedFranchise.value}`,
                {
                    franchiseId: selectedFranchise.value,
                },
                sessionToken
            );

            // Update local form data
            setFormData((prev) => ({
                ...prev,
                franchiseId: selectedFranchise.value,
                franchiseName: selectedFranchise.label,
            }));

            alert("Franchise assigned successfully!");
            setAssignPopup(false);
            setSelectedFranchise(null);

        } catch (error) {
            console.error(error);
            alert("Failed to assign franchise");
        } finally {
            setAssignLoading(false);
        }
    };

    const handleRemoveFranchise = async () => {
        if (!formData._id) {
            alert("Store ID missing");
            return;
        }

        if (!window.confirm("Are you sure you want to remove the assigned franchise?")) {
            return;
        }
        debugger;
        try {
            setAssignLoading(true);
            const sessionToken = localStorage.getItem("Token");

            await deleteData(
                `stores/store/${formData._id}/franchise/${formData.franchiseId}`,
                sessionToken
            );

            setFormData((prev) => ({
                ...prev,
                franchiseId: "",
                franchiseName: "",
            }));

            alert("Franchise removed successfully!");

        } catch (error) {
            console.error("Remove franchise failed:", error);
            alert("Failed to remove franchise");
        } finally {
            setAssignLoading(false);
        }
    };

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra & Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];




    return (
        <div className="product-layout">
            <div className="product-content">
                {showLoader && (
                    <div className="scissor-overlay">
                        <div className="scissor-loader">
                            <TVFMLoader />
                        </div>
                    </div>
                )}
                <main className="product-main">
                    {isAddStore ? (
                        <AddStoreForm onSuccess={() => {
                            navigate("/stores");
                            triggerRefresh();
                        }} />
                    ) : (
                        <>
                            <Typography variant="h6" mb={2}>Stores</Typography>
                            <div className="product-widgets">
                                <div className="search-input-wrapper">
                                    <input
                                        type="text"
                                        placeholder="Search stores..."
                                        className="store-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <Icon icon="mdi:magnify" className="search-icon" />
                                </div>
                                <button className="add-Product-button" disabled={isFranchiseAdmin} onClick={() => navigate('/stores/add')}>+ Add Store</button>
                            </div>
                            <Box component={Paper}>
                                <TableContainer sx={{
                                    overflow: 'auto',
                                    maxHeight: '400px',
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}>
                                    <Table className="custom-product-table"
                                        sx={{
                                            '& td, & th': {
                                                border: 'none',
                                            },
                                            border: 'none',
                                        }}>
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {

                                                    const sortKey =
                                                        heading === "Store Name" || heading === "Name" ? "branchName" :
                                                            heading === "Location" ? "location" :
                                                                heading === "Email" ? "emailAddress" :
                                                                    heading === "Phone Number" ? "phoneNumber" :   // ✅ FIXED
                                                                        heading === "Created Date" ? "createdAt" :
                                                                            heading === "Revenue" ? "totalRevenue" :
                                                                                null;

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 1,
                                                                backgroundColor: '#3C0008',
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {stores.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={headings.length}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No Stores found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                stores.map((store, index) => (
                                                    <TableRow key={store._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{getStoreDisplayName(store)}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{store.emailAddress}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{store.phoneNumber}</Typography></TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Store">
                                                                    <Icon
                                                                        icon={plusIcon}
                                                                        width={24}
                                                                        height={24}
                                                                        onClick={() => handleViewStore(store._id)}
                                                                    />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Store">
                                                                    <Icon
                                                                        icon={editIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={async () => {
                                                                            try {
                                                                                setLoaderText("Loading store details...");

                                                                                const sessionToken = localStorage.getItem("Token");

                                                                                // 1️⃣ Fetch store details from backend
                                                                                const res = await getData(`stores/store/${store._id}`, {}, sessionToken);
                                                                                const storeDetails = res.data;
                                                                                const isFranchiseAvailable = !!storeDetails.franchiseId;
                                                                                // 2️⃣ Update formData with full backend data
                                                                                const storeAdminId =
                                                                                    storeDetails.storeAdmin?._id || storeDetails.storeAdmin || "";

                                                                                const storeAdminName =
                                                                                    storeDetails.storeAdmin?.name ||
                                                                                    storeDetails.storeAdmin?.email ||
                                                                                    "";
                                                                                setFormData({
                                                                                    _id: storeDetails._id,
                                                                                    storeName: storeDetails.branchName || storeDetails.storeName || "",
                                                                                    branchName: storeDetails.branchName || "",
                                                                                    emailAddress: storeDetails.emailAddress || "",
                                                                                    phoneNumber: storeDetails.phoneNumber || "",
                                                                                    address: storeDetails.address || "",
                                                                                    postalCode: storeDetails.postalCode || "",
                                                                                    brandName: storeDetails.brandName || "",
                                                                                    state: storeDetails.state || "",
                                                                                    country: storeDetails.country || "",
                                                                                    location: storeDetails.location || "",
                                                                                    storeAdmin: storeAdminId,
                                                                                    gstData: {
                                                                                        gstNumber: "",
                                                                                        valid: storeDetails.gstData?.valid,
                                                                                        status: storeDetails.gstData?.status,
                                                                                    },
                                                                                    storeAdminName: storeAdminName,
                                                                                    // ⭐ Franchise from virtual field
                                                                                    isFranchiseAvailable,
                                                                                    franchiseId: storeDetails.franchisor?._id || "",
                                                                                    franchiseName: storeDetails.franchisor?.franchiseName || "",
                                                                                    storeImageObject: storeDetails.storeImageObject || "",
                                                                                    storeLogoImageObject: storeDetails.storeLogoImageObject || "",
                                                                                });

                                                                                setPreviewUrl(
                                                                                    storeDetails?.storeImageObject?.uri
                                                                                        ? `${process.env.REACT_APP_API_URL}${storeDetails.storeImageObject.uri}`
                                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                                );

                                                                                setLogoPreviewUrl(
                                                                                    storeDetails?.storeLogoImageObject?.uri
                                                                                        ? `${process.env.REACT_APP_API_URL}${storeDetails.storeLogoImageObject.uri}`
                                                                                        : null
                                                                                );

                                                                                // 3️⃣ Documents
                                                                                setDocuments(
                                                                                    storeDetails.documents?.map(d => ({
                                                                                        documentType: d.documentType,
                                                                                        documentName: d.documentName,
                                                                                        files: d.files
                                                                                    })) || [{ documentType: "", documentName: "", files: [] }]
                                                                                );

                                                                                // 4️⃣ Open popup
                                                                                setEditStoreId(storeDetails._id);
                                                                                setStoreImage(null);
                                                                                setStoreLogo(null);
                                                                                setIsPopupMode(true);
                                                                                setIsEditMode(true);
                                                                                setLoaderText("Updating Store...");

                                                                            } catch (error) {
                                                                                console.error("Failed to load store data", error);
                                                                                alert("Error loading store details");
                                                                            }
                                                                        }}

                                                                    />
                                                                </Tooltip>
                                                                {role !== "SelfAdmin" && role !== "StoreCreator" && (
                                                                    <Tooltip title="Delete Store">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            disabled={isFranchiseAdmin} onClick={() => handleOpen(store._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>

                                                        </TableCell>
                                                    </TableRow>

                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="store-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="product-section showing-range">
                                        {limit === "all"
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="product-section spacer"></div>
                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        >
                                            <Icon icon="mdi:chevron-double-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        ><Icon icon='mdi:chevron-left' /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("next")}
                                        ><Icon icon='mdi:chevron-right' /></button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange("last")}
                                        ><Icon icon='mdi:chevron-double-right' /></button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setLoaderText('');
                                            }}
                                        />

                                        <div className="popup-form">
                                            {/* Assign / Remove Franchise Button Bar */}
                                            <div
                                                className="assign-row"
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    alignItems: "center",
                                                    marginBottom: "15px",
                                                    gap: "10px"
                                                }}
                                            >
                                                {!formData.franchiseId ? (
                                                    <button
                                                        type="button"
                                                        className="add-Product-button"
                                                        onClick={() => setAssignPopup(true)}
                                                        style={{ padding: "8px 14px" }}
                                                    >
                                                        Assign Franchise
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="add-Product-button"
                                                        onClick={handleRemoveFranchise}
                                                        style={{ padding: "8px 14px" }}
                                                    >
                                                        Remove Franchise
                                                    </button>
                                                )}

                                                <button
                                                    type="button"
                                                    className="add-Product-button"
                                                    onClick={() => openRenewPackageModal(formData._id)}
                                                    style={{ padding: "8px 14px", backgroundColor: "#dc2626", display: "flex", alignItems: "center", gap: "6px" }}
                                                >
                                                    <Icon icon="solar:restart-bold-duotone" />
                                                    Renew / Change Package
                                                </button>

                                                {formData.franchiseId && (
                                                    <span style={{ fontSize: "14px", color: "#444" }}>
                                                        Assigned: <strong>{formData.franchiseName}</strong>
                                                    </span>
                                                )}
                                            </div>


                                            <Typography variant="h6" textAlign="center" mb={4}>
                                                Edit Store
                                            </Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateStore}>
                                                {/* ROW 1 */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <input
                                                            type="text"
                                                            value={formData.branchName}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, branchName: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Store Email Address</label>
                                                        <input
                                                            type="text"
                                                            value={formData.emailAddress}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, emailAddress: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Store Phone Number</label>
                                                        <input
                                                            type="text"
                                                            maxLength={10}
                                                            value={formData.phoneNumber}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        phoneNumber: value,
                                                                    }));
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                </div>


                                                {/* ROW 2 */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Store Address</label>
                                                        <input
                                                            type="text"
                                                            value={formData.address}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, address: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Postal Code</label>
                                                        <input
                                                            type="text"
                                                            value={formData.postalCode}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, postalCode: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">State</label>
                                                        <select className="category-input" value={formData.state || ""}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, state: e.target.value }))}
                                                        >
                                                            <option value="">Select State</option>

                                                            {indianStates.map((state, index) => (
                                                                <option key={index} value={state}>
                                                                    {state}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">Country</label>
                                                        <input
                                                            type="text"
                                                            value={formData.country}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, country: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Location</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter Area / Locality"
                                                            value={formData.location}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, location: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="input-label">Brand Name</label>
                                                        <input
                                                            type="text"
                                                            value={formData.brandName}
                                                            disabled={isFranchiseAdmin}
                                                            onChange={(e) => {
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    brandName: e.target.value,
                                                                }));
                                                            }}
                                                        />
                                                    </div>

                                                </div>

                                                {/* ROW 4: GST & Description */}
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label className="input-label">GST Number</label>
                                                        <input
                                                            type="text"
                                                            className="store-input"
                                                            value={formData.gstData?.gstNumber || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    gstData: {
                                                                        ...prev.gstData,
                                                                        gstNumber: e.target.value,
                                                                    },
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group" style={{ flex: 1 }}>
                                                        <label className="input-label">GST Status</label>
                                                        <select
                                                            className="store-input"
                                                            value={formData.gstData?.status || "PENDING"}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    gstData: {
                                                                        ...prev.gstData,
                                                                        status: e.target.value,
                                                                    },
                                                                }))
                                                            }
                                                        >
                                                            <option value="PENDING">PENDING</option>
                                                            <option value="VERIFIED">VERIFIED</option>
                                                            <option value="REJECTED">REJECTED</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="form-group-row">
                                                    <label className="input-label">Store Documents</label>

                                                    <div className="document-list">
                                                        {documents.map((doc, idx) => (
                                                            <div key={idx} className="document-row-single">
                                                                <button

                                                                    type="button"
                                                                    className="remove-doc-btn"
                                                                    onClick={() => removeDocumentRow(idx)}
                                                                >
                                                                    ✕
                                                                </button>
                                                                <select
                                                                    disabled={isFranchiseAdmin}
                                                                    className="store-input"
                                                                    value={doc.documentType}
                                                                    onChange={(e) =>
                                                                        updateDocumentRow(idx, "documentType", e.target.value)
                                                                    }
                                                                >
                                                                    <option value="">Select Document Type</option>
                                                                    <option value="RENTAL AGREEMENT">RENTAL AGREEMENT</option>
                                                                    <option value="OTHERS">OTHERS</option>
                                                                </select>
                                                                {doc.documentType === "OTHERS" && (
                                                                    <input
                                                                        type="text"
                                                                        className="store-input"
                                                                        placeholder="Document Name"
                                                                        value={doc.documentName}
                                                                        onChange={(e) =>
                                                                            updateDocumentRow(idx, "documentName", e.target.value)
                                                                        }
                                                                    />
                                                                )}
                                                                {doc.files && doc.files.length > 0 && (
                                                                    <div className="uploaded-file-list">
                                                                        {doc.files.map((file, fIdx) => (
                                                                            <div key={fIdx} className="uploaded-file-item">
                                                                                <a
                                                                                    href={process.env.REACT_APP_API_URL + file.uri}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    {file.fileName || "View File"}
                                                                                </a>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                <input
                                                                    type="file"
                                                                    multiple
                                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                                    className="store-input"
                                                                    onChange={(e) => handleDocumentFiles(idx, e.target.files)}
                                                                />
                                                            </div>
                                                        ))}

                                                        <button
                                                            type="button"
                                                            className="add-row-btn"
                                                            disabled={documents.length >= 10}
                                                            onClick={addDocumentRow}
                                                        >
                                                            + Add Document Row
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* LAST ROW: Store Image & Store Logo */}
                                                <div className="form-group-row" style={{ justifyContent: 'space-around', marginTop: '25px' }}>
                                                    <div className="form-group" style={{ alignItems: 'center', maxWidth: '300px' }}>
                                                        <label htmlFor="storeImage" className="input-label" style={{ textAlign: 'center', width: '100%' }}>Store Image</label>
                                                        <div className="file-input-wrapper" style={{ width: '100%' }}>
                                                            <input
                                                                type="file"
                                                                id="storeImage"
                                                                accept="image/*"
                                                                className="store-input"
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file && file.size > 2 * 1024 * 1024) {
                                                                        toast.error("The uploaded image size exceeds the maximum allowed limit of 2 MB. Please upload an image smaller than 2 MB.");
                                                                        e.target.value = "";
                                                                        return;
                                                                    }
                                                                    setStoreImage(file);
                                                                    setPreviewUrl(file ? URL.createObjectURL(file) : null);
                                                                }}
                                                            />
                                                        </div>
                                                        {previewUrl && (
                                                            <div className="image-preview" style={{ marginTop: '15px', position: 'relative', display: 'inline-block' }}>
                                                                <img src={previewUrl} alt="Store Preview" style={{ width: '140px', height: '140px', borderRadius: '15px', objectFit: 'cover', border: '2px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setStoreImage(null);
                                                                        setPreviewUrl(null);
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            storeImageObject: null
                                                                        }));
                                                                        const fileInput = document.getElementById("storeImage");
                                                                        if (fileInput) fileInput.value = "";
                                                                    }}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-8px',
                                                                        right: '-8px',
                                                                        background: '#C10000',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '50%',
                                                                        width: '24px',
                                                                        height: '24px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'bold',
                                                                        zIndex: 10
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="form-group" style={{ alignItems: 'center', maxWidth: '300px' }}>
                                                        <label htmlFor="storeLogo" className="input-label" style={{ textAlign: 'center', width: '100%' }}>Store Logo</label>
                                                        <div className="file-input-wrapper" style={{ width: '100%' }}>
                                                            <input
                                                                type="file"
                                                                id="storeLogo"
                                                                accept="image/*"
                                                                className="store-input"
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file && file.size > 2 * 1024 * 1024) {
                                                                        toast.error("The uploaded image size exceeds the maximum allowed limit of 2 MB. Please upload an image smaller than 2 MB.");
                                                                        e.target.value = "";
                                                                        return;
                                                                    }
                                                                    setStoreLogo(file);
                                                                    setLogoPreviewUrl(file ? URL.createObjectURL(file) : null);
                                                                }}
                                                            />
                                                        </div>
                                                        {logoPreviewUrl && (
                                                            <div className="image-preview" style={{ marginTop: '15px', position: 'relative', display: 'inline-block' }}>
                                                                <img src={logoPreviewUrl} alt="Logo Preview" style={{ width: '140px', height: '140px', borderRadius: '15px', objectFit: 'cover', border: '2px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setStoreLogo(null);
                                                                        setLogoPreviewUrl(null);
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            storeLogoImageObject: null
                                                                        }));
                                                                        const fileInput = document.getElementById("storeLogo");
                                                                        if (fileInput) fileInput.value = "";
                                                                    }}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-8px',
                                                                        right: '-8px',
                                                                        background: '#C10000',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '50%',
                                                                        width: '24px',
                                                                        height: '24px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'bold',
                                                                        zIndex: 10
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <div className="form-actions">
                                                            <button type="submit" className="add-Product-button">
                                                                Update Store
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="cancel-Product-button"
                                                                onClick={() => setIsPopupMode(false)}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        {/* ----------------- Assign Franchise Popup ----------------- */}
                                        {assignPopup && (
                                            <div
                                                className="popup-overlay"
                                                style={{
                                                    position: "fixed",
                                                    inset: 0,
                                                    background: "rgba(0,0,0,0.45)",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    zIndex: 9999,
                                                }}
                                            >
                                                <div
                                                    className="popup-small"
                                                    style={{
                                                        background: "#fff",
                                                        width: "100%",
                                                        maxWidth: 500,
                                                        padding: 20,
                                                        borderRadius: 10,
                                                        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                                                    }}
                                                >
                                                    <h3
                                                        className="popup-title"
                                                        style={{ marginBottom: 15, fontSize: 18, fontWeight: 600 }}
                                                    >
                                                        Assign Franchise
                                                    </h3>

                                                    <AsyncPaginate
                                                        value={selectedFranchise}
                                                        loadOptions={loadFranchises}
                                                        onChange={(value) => setSelectedFranchise(value)}
                                                        additional={{ page: 1 }}
                                                        placeholder="Search Franchise..."
                                                        isClearable
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                borderColor: "#ddd",
                                                                padding: 2,
                                                                borderRadius: 8,
                                                            }),
                                                        }}
                                                    />

                                                    <div
                                                        className="popup-actions"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            marginTop: 20,
                                                            gap: 10,
                                                        }}
                                                    >
                                                        <button
                                                            className="cancel-Product-button"
                                                            type="button"
                                                            onClick={() => {
                                                                setAssignPopup(false);
                                                                setSelectedFranchise(null);
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>

                                                        <button
                                                            className="add-Product-button"
                                                            type="button"
                                                            disabled={assignLoading}
                                                            onClick={handleAssignFranchise}
                                                        >
                                                            {assignLoading ? "Assigning..." : "Assign"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            )}
                            {limit > 5 && stores.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Stores
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this store?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <Button
                                            variant="contained"
                                            onClick={handleDeleteStore}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </Button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <Button
                                            variant="outlined"
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}

                    {/* VIEW STORE MODAL */}
                    <Modal
                        open={isViewStore}
                        onClose={() => setIsViewStore(false)}
                        aria-labelledby="view-store-title"
                        aria-describedby="view-store-description"
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(5px)', bgcolor: 'rgba(15, 23, 42, 0.2)' }}
                    >
                        <Box sx={{
                            width: '100%', maxWidth: 900, maxHeight: '90vh', bgcolor: '#ffffff',
                            borderRadius: '24px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                            overflow: 'hidden', display: 'flex', flexDirection: 'column',
                            border: '1px solid #e2e8f0', outline: 'none'
                        }}>
                            {/* Colorful Header */}
                            <Box sx={{
                                px: 4, py: 3,
                                background: 'linear-gradient(135deg, #3C0008 0%, #6d000e 100%)',
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                borderBottom: '1px solid #3C0008', zIndex: 10
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Box sx={{
                                        width: 48, height: 48, borderRadius: '12px', bgcolor: 'rgba(255,255,255,0.2)', color: '#fff',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)',
                                        overflow: 'hidden'
                                    }}>
                                        {viewStoreData?.storeLogoImageObject?.uri ? (
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}${viewStoreData.storeLogoImageObject.uri}`}
                                                alt="Logo"
                                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                            />
                                        ) : (
                                            <Icon icon="mdi:storefront" fontSize={26} />
                                        )}
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontWeight: 800, fontSize: '18px', color: '#fff', lineHeight: 1.2 }}>
                                            {viewStoreData?.storeName || 'Store Details'}
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '12px', fontWeight: 500 }}>
                                                {viewStoreData?.branchName || 'Branch N/A'}
                                            </Typography>
                                            <Box sx={{ px: 1, py: 0.2, borderRadius: '4px', bgcolor: '#22c55e', color: '#fff', fontSize: '10px', fontWeight: 700 }}>
                                                ACTIVE
                                            </Box>
                                            {viewStoreData?.brandName && (
                                                <Box sx={{ px: 1, py: 0.2, borderRadius: '4px', bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: '10px', fontWeight: 700 }}>
                                                    {viewStoreData.brandName.toUpperCase()}
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                </Box>
                                <Button
                                    onClick={() => setIsViewStore(false)}
                                    sx={{ minWidth: 40, width: 40, height: 40, borderRadius: '50%', color: '#fff', bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)', color: '#fff' } }}
                                >
                                    <Icon icon="mdi:close" fontSize={24} />
                                </Button>
                            </Box>

                            {/* Content Body */}
                            <Box sx={{
                                p: 4, overflowY: 'auto', flex: 1, bgcolor: '#f8fafc',
                                '&::-webkit-scrollbar': { width: '5px' },
                                '&::-webkit-scrollbar-track': { background: 'transparent' },
                                '&::-webkit-scrollbar-thumb': { background: '#cbd5e1', borderRadius: '10px' }
                            }}>
                                {viewStoreData ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                                        {/* Row 1: Hero Section (Image & Concise Description) */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2, textAlign: 'center' }}>
                                            <Paper elevation={0} sx={{
                                                p: 1.5, borderRadius: '24px', bgcolor: '#fff', border: '1px solid #e2e8f0',
                                                width: '100%', maxWidth: 480, overflow: 'hidden', mb: 2,
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                            }}>
                                                <Box sx={{
                                                    borderRadius: '20px', overflow: 'hidden', bgcolor: '#f1f5f9',
                                                    aspectRatio: '16/9', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                }}>
                                                    {viewStoreData.storeImageObject?.uri ? (
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}${viewStoreData.storeImageObject.uri}`}
                                                            alt="Store"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    ) : (
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                                            <Icon icon="mdi:image-filter-hdr" fontSize={64} color="#cbd5e1" />
                                                            <Typography sx={{ fontSize: '14px', color: '#94a3b8', fontWeight: 600 }}>No Store Image</Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Paper>
                                            {viewStoreData.description && (
                                                <Box sx={{ maxWidth: 700, px: 2 }}>
                                                    <Typography sx={{
                                                        fontSize: '14px', color: '#64748b', fontStyle: 'italic', lineHeight: 1.6,
                                                        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}>
                                                        {viewStoreData.description}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>

                                        {/* Row 2: Info & Details Grid */}
                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 3 }}>
                                            {/* Info Grid */}
                                            <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', bgcolor: '#fff', border: '1px solid #e2e8f0' }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '1px', mb: 2 }}>
                                                    Contact & Location
                                                </Typography>
                                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f9f1f2', border: '1px solid #f1e2e4' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                            <Icon icon="mdi:email" color="#3C0008" width={16} />
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#3C0008' }}>EMAIL</Typography>
                                                        </Box>
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis' }}>{viewStoreData.emailAddress || 'N/A'}</Typography>
                                                    </Box>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f9f1f2', border: '1px solid #f1e2e4' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                            <Icon icon="mdi:phone" color="#3C0008" width={16} />
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#3C0008' }}>PHONE</Typography>
                                                        </Box>
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>{viewStoreData.phoneNumber || 'N/A'}</Typography>
                                                    </Box>
                                                    <Box sx={{ gridColumn: 'span 2', p: 1.5, borderRadius: '12px', bgcolor: '#f9f1f2', border: '1px solid #f1e2e4' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                                            <Icon icon="mdi:map-marker" color="#3C0008" width={16} />
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#3C0008' }}>ADDRESS</Typography>
                                                        </Box>
                                                        <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#334155' }}>
                                                            {viewStoreData.address}, {viewStoreData.location && `${viewStoreData.location}, `}{viewStoreData.state}, {viewStoreData.country} - {viewStoreData.postalCode}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Paper>

                                            {/* People & Roles */}
                                            <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', bgcolor: '#fff', border: '1px solid #e2e8f0' }}>
                                                <Typography sx={{ fontSize: '11px', fontWeight: 800, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '1px', mb: 2 }}>
                                                    Management Team
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                                    {(() => {
                                                        const franchiseAdmin = viewStoreData.franchisor?.franchiseAdmin?.[0]; // Get first franchise admin
                                                        const storeAdminRaw = viewStoreData.storeAdmin;
                                                        const storeAdmin = Array.isArray(storeAdminRaw) ? storeAdminRaw[0] : storeAdminRaw;

                                                        return [
                                                            {
                                                                label: 'Franchise Admin',
                                                                value: franchiseAdmin?.name,
                                                                icon: 'mdi:account-star',
                                                                color: '#3C0008',
                                                                bg: '#f9f1f2'
                                                            },
                                                            {
                                                                label: 'Cluster Manager',
                                                                value: viewStoreData.clusterManager?.name,
                                                                icon: 'mdi:account-group',
                                                                color: '#3C0008',
                                                                bg: '#f9f1f2'
                                                            },
                                                            {
                                                                label: 'Store Admin',
                                                                value: storeAdmin ? storeAdmin.name : 'Not Assigned',
                                                                icon: 'mdi:account-tie',
                                                                color: '#3C0008',
                                                                bg: '#f9f1f2'
                                                            }
                                                        ].map((item, i) => (
                                                            <Box key={i} sx={{
                                                                p: 1.2, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 1.5,
                                                                transition: 'all 0.2s', '&:hover': { transform: 'translateX(4px)', borderColor: item.color }
                                                            }}>
                                                                <Box sx={{ width: 32, height: 32, borderRadius: '8px', bgcolor: item.bg, color: item.color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                    <Icon icon={item.icon} fontSize={18} />
                                                                </Box>
                                                                <Box sx={{ overflow: 'hidden', flex: 1 }}>
                                                                    <Typography sx={{ fontSize: '9px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase' }}>{item.label}</Typography>
                                                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.value || 'Not Assigned'}</Typography>
                                                                </Box>
                                                            </Box>
                                                        ));
                                                    })()}
                                                </Box>
                                            </Paper>
                                        </Box>

                                        {/* Row 2.5: Subscription Package Details (Only rendered if package was chosen) */}
                                        {(() => {
                                            const sub = viewStoreData.purchaseDetails || viewStoreData.subscriptionDetails || viewStoreData.packageDetails;
                                            if (!sub || !sub.packageName) return null;

                                            const status = sub?.subscriptionStatus || 'Active';
                                            const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'N/A';

                                            return (
                                                <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', bgcolor: '#fff', border: '1px solid #e2e8f0', mb: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <Icon icon="mdi:package-variant-closed" color="#3C0008" fontSize={22} />
                                                            <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                                Subscription Package Details
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                            <Button
                                                                variant="contained"
                                                                size="small"
                                                                onClick={() => {
                                                                    const sId = sub?._id || sub?.id || viewStoreData?._id;
                                                                    setInvoiceSubId(sId);
                                                                    setIsInvoiceModalOpen(true);
                                                                }}
                                                                startIcon={<Icon icon="solar:printer-bold-duotone" />}
                                                                sx={{
                                                                    bgcolor: '#3C0008',
                                                                    color: '#ffffff',
                                                                    textTransform: 'none',
                                                                    fontWeight: 700,
                                                                    fontSize: '11px',
                                                                    borderRadius: '8px',
                                                                    px: 1.5,
                                                                    '&:hover': { bgcolor: '#2a0005' }
                                                                }}
                                                            >
                                                                Print Invoice
                                                            </Button>
                                                            <Chip
                                                                label={status}
                                                                size="small"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    fontSize: '11px',
                                                                    bgcolor: status === 'Active' ? '#dcfce7' : status === 'Renewed' ? '#dbeafe' : '#fef3c7',
                                                                    color: status === 'Active' ? '#166534' : status === 'Renewed' ? '#1e40af' : '#92400e'
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 2 }}>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Package Name</Typography>
                                                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#3C0008' }}>{sub.packageName || 'N/A'}</Typography>
                                                        </Box>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Price & GST</Typography>
                                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#1e293b' }}>
                                                                ₹{Number(sub.packagePrice || 0).toLocaleString('en-IN')} {sub.isGstApplicable ? `(${sub.gstPercentage}% ${sub.gstType || ''})` : ''}
                                                            </Typography>
                                                        </Box>
                                                        {(() => {
                                                            const price = Number(sub.packagePrice) || 0;
                                                            const gst = Number(sub.gstPercentage) || 0;
                                                            let gstAmt = 0;
                                                            let totalAmt = price;
                                                            if (sub.isGstApplicable && gst > 0) {
                                                                if (sub.gstType === 'Exclusive') {
                                                                    gstAmt = (price * gst) / 100;
                                                                    totalAmt = price + gstAmt;
                                                                } else if (sub.gstType === 'Inclusive') {
                                                                    gstAmt = price - (price / (1 + gst / 100));
                                                                    totalAmt = price;
                                                                }
                                                            }
                                                            const displayGstAmt = sub.gstAmount !== undefined ? sub.gstAmount : Number(gstAmt.toFixed(2));
                                                            const displayTotalAmt = sub.totalAmount !== undefined ? sub.totalAmount : Number(totalAmt.toFixed(2));

                                                            return (
                                                                <>
                                                                    <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                        <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>GST Amount</Typography>
                                                                        <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#475569' }}>
                                                                            ₹{Number(displayGstAmt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                        <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Total Amount</Typography>
                                                                        <Typography sx={{ fontSize: '14px', fontWeight: 800, color: '#166534' }}>
                                                                            ₹{Number(displayTotalAmt).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </Typography>
                                                                    </Box>
                                                                </>
                                                            );
                                                        })()}
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Total Validity</Typography>
                                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#2563eb' }}>{sub.totalValidity || `${sub.baseValidity || 0} ${sub.validityUnit || ''}`}</Typography>
                                                        </Box>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Validity Start Date</Typography>
                                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#16a34a' }}>{formatDate(sub.validityStartDate)}</Typography>
                                                        </Box>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Base Expiry Date</Typography>
                                                            <Typography sx={{ fontSize: '13.5px', fontWeight: 700, color: '#475569' }}>{formatDate(sub.baseExpiryDate)}</Typography>
                                                        </Box>
                                                        <Box sx={{ p: 1.5, borderRadius: '12px', bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                            <Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>Final Expiry Date</Typography>
                                                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#dc2626' }}>{formatDate(sub.finalExpiryDate)}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Paper>
                                            );
                                        })()}

                                        {/* Row 3: Compliance & Documents */}
                                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 3 }}>
                                            {/* GST Card */}
                                            <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', bgcolor: '#fff', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                                                    <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                                        GST Compliance
                                                    </Typography>
                                                    <Icon icon="mdi:shield-check" color="#3C0008" fontSize={20} />
                                                </Box>

                                                {(() => {
                                                    const storeGst = viewStoreData.gstData;
                                                    const franchisorGst = viewStoreData.franchisor?.gstData;
                                                    const franchiseIdGst = viewStoreData.franchiseId?.gstData;

                                                    // Helper to check if valid
                                                    const isValidGst = (g) => g && g.gstNumber && g.gstNumber.trim() !== '';

                                                    // Priority: Store -> Franchisor -> Franchise
                                                    const activeGst = isValidGst(storeGst) ? storeGst :
                                                        (isValidGst(franchisorGst) ? franchisorGst : franchiseIdGst);

                                                    const status = activeGst?.status || 'PENDING';

                                                    return (
                                                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                            <Box sx={{
                                                                p: 3, borderRadius: '16px',
                                                                bgcolor: status === 'VERIFIED' ? '#f9f1f2' : '#fffbeb',
                                                                border: status === 'VERIFIED' ? '1px solid #f1e2e4' : '1px solid #fde68a',
                                                                textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1
                                                            }}>
                                                                <Icon
                                                                    icon={status === 'VERIFIED' ? "mdi:check-decagram" : "mdi:clock-outline"}
                                                                    fontSize={40}
                                                                    color={status === 'VERIFIED' ? '#3C0008' : '#f59e0b'}
                                                                />
                                                                <Typography sx={{ fontSize: '18px', fontWeight: 900, color: status === 'VERIFIED' ? '#3C0008' : '#92400e', textTransform: 'uppercase' }}>
                                                                    {status}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '11px', color: '#64748b', fontWeight: 600 }}>
                                                                    GST Status: {status === 'VERIFIED' ? 'Verified & Valid' : 'Under Review'}
                                                                </Typography>
                                                            </Box>

                                                            {activeGst?.gstImage && (
                                                                <Button
                                                                    fullWidth
                                                                    variant="contained"
                                                                    startIcon={<Icon icon="mdi:file-eye" />}
                                                                    sx={{
                                                                        borderRadius: '12px', bgcolor: '#3C0008', textTransform: 'none', fontWeight: 700,
                                                                        '&:hover': { bgcolor: '#6d000e' }, mt: 1
                                                                    }}
                                                                    onClick={() => window.open(process.env.REACT_APP_API_URL + activeGst.gstImage, '_blank')}
                                                                >
                                                                    View Certificate
                                                                </Button>
                                                            )}
                                                        </Box>
                                                    );
                                                })()}
                                            </Paper>

                                            {/* Digital Assets */}
                                            <Paper elevation={0} sx={{ p: 3, borderRadius: '20px', bgcolor: '#fff', border: '1px solid #e2e8f0' }}>
                                                <Typography sx={{ fontSize: '12px', fontWeight: 800, color: '#3C0008', textTransform: 'uppercase', letterSpacing: '1px', mb: 3 }}>
                                                    Digital Vault
                                                </Typography>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                    {viewStoreData.documents?.length > 0 ? (
                                                        viewStoreData.documents.map((doc, idx) => (
                                                            <Box key={idx} sx={{
                                                                p: 2, borderRadius: '12px', border: '1px solid #e2e8f0', bgcolor: '#fff',
                                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                                                transition: 'all 0.2s', '&:hover': { bgcolor: '#f8fafc', borderColor: '#3b82f6' }
                                                            }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                                    <Box sx={{ width: 36, height: 36, borderRadius: '8px', bgcolor: '#f9f1f2', color: '#3C0008', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Icon icon="mdi:file-document" fontSize={20} />
                                                                    </Box>
                                                                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#334155' }}>{doc.documentType}</Typography>
                                                                </Box>
                                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                                    {doc.files?.map((file, fi) => (
                                                                        <Button key={fi} size="small" variant="outlined" sx={{
                                                                            minWidth: 0, p: '6px 12px', borderRadius: '8px',
                                                                            borderColor: '#f1e2e4', color: '#3C0008', textTransform: 'none', fontSize: '12px', fontWeight: 600,
                                                                            '&:hover': { bgcolor: '#3C0008', color: '#fff', borderColor: '#3C0008' }
                                                                        }}
                                                                            onClick={() => window.open(file.fileUri || (process.env.REACT_APP_API_URL + file.uri), '_blank')}
                                                                        >
                                                                            View File
                                                                        </Button>
                                                                    ))}
                                                                </Box>
                                                            </Box>
                                                        ))
                                                    ) : (
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, opacity: 0.5 }}>
                                                            <Icon icon="mdi:folder-open-outline" fontSize={40} />
                                                            <Typography sx={{ fontSize: '13px', mt: 1 }}>No Documents</Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Paper>
                                        </Box>

                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', py: 10 }}>
                                        <TVFMLoader />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Modal>
                </main>
                <PackageInvoiceModal
                    isOpen={isInvoiceModalOpen}
                    onClose={() => setIsInvoiceModalOpen(false)}
                    subscriptionId={invoiceSubId}
                />
                <Footer />
            </div >
        </div >
    );

};

export default StorePage;
